<template>
    <div class="list-section">
        <!-- 标题区 -->
        <div class="title-wrap">
            <!-- 标题 -->
            <span class="title">
                <van-icon :name="titleIcon" :style="{'color':iconColor}" />
                {{title}}
            </span>

            <!-- 查看更多 -->
            <router-link v-if="lookMore !== false" class="look-more" :to="lookMore">查看更多<van-icon name="arrow" /></router-link>
        </div>

        <!-- 内容区 -->
        <div class="content">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "listSection",
    props:{
        lookMore:{
            type:[Object,Boolean],
            required:true
        },
        title:{
            type:String,
        },
        titleIcon:{
            type:String,
        },
        iconColor:{
            type:String,
        }
    }
}
</script>

<style scoped>
.list-section{
    padding:0 2.4vw;
    margin-bottom: 4vw;
}
.title-wrap{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.title{
    font-size: 1.3rem;
    font-weight: bold;
    font-family: PingFang SC;
}
.look-more{
    color: #4E4E4E;
}
.content{
    margin-top: 5.3vw;
}
</style>
